import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from '../../../../tms-shared';
import { SalesOrderHeaderDeliveryItem } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderDeliveryItemService extends TmsWebBaseEditCreateService<
  SalesOrderHeaderDeliveryItem,
  SalesOrderHeaderDeliveryItem
> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SalesOrderDeliveryItem', $localize`Sales Order Delivery Item`, httpService, notificationService);
  }

  getForSalesOrderHeader(id: string): Observable<SalesOrderHeaderDeliveryItem[]> {
    return this.httpService.get<SalesOrderHeaderDeliveryItem[]>(`${this.apiUrl}/SalesOrderHeader?id=${id}`);
  }
}
